import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { KUBERNETES_CLUSTER_TYPE, routes } from '../../lib/viva';
import { EntityArgoAppsCell } from './cells';
import { clusterColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const columns = clusterColumns<CatalogTableRow>(row => (
  <EntityArgoAppsCell entity={row.entity} />
));

export const ClustersPage = () => (
  <TypedCatalogPage
    section="clusters"
    title="Кластеры"
    subtitle="Kubernetes-кластеры платформы и состояние их приложений в ArgoCD"
    kind="resource"
    type={KUBERNETES_CLUSTER_TYPE}
    columns={columns}
    create={{ title: 'Новый кластер', to: routes.newCluster }}
    support="Кластер создаётся шаблоном «Новый Kubernetes-кластер»: пайплайн viva/clusters поднимает его, регистрирует GitLab Agent и заводит эту запись в каталоге."
    emptyContent={
      <EmptyState
        missing="data"
        title="Кластеров пока нет"
        description="Создайте первый кластер из шаблона «Новый Kubernetes-кластер» — он появится здесь после регистрации в каталоге."
        action={
          <Button variant="contained" color="primary" href={routes.newCluster}>
            Новый кластер
          </Button>
        }
      />
    }
  />
);
